import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { InlineSearchCommands } from '../enums';

export class InlineSearchAppUserKeyboardEvent implements IEvent {
	public static readonly EventType =
		InlineSearchCommands.INLINE_SEARCH_APP_USER_KEYBOARD_EVENT;
	public readonly timestamp = new Date();
	public readonly eventType = InlineSearchAppUserKeyboardEvent.EventType;
	public readonly keyboardEvent: KeyboardEvent;

	constructor(keyboardEvent: KeyboardEvent) {
		this.keyboardEvent = keyboardEvent;
	}

	public static is(event: IEvent): event is InlineSearchAppUserKeyboardEvent {
		return (
			event.eventType === (InlineSearchAppUserKeyboardEvent.EventType as string)
		);
	}
}